if (!customElements.get('gx-sort-dropdown')) {
  customElements.define(
    'gx-sort-dropdown',
    class GxSortDropdown extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('.gx-sort-dropdown__trigger');
        this.panel = this.querySelector('.gx-sort-dropdown__panel');
        this.closeButton = this.querySelector('.gx-sort-dropdown__panel-close');
        this.select = this.querySelector('select[name="sort_by"]');
        this.options = Array.from(this.querySelectorAll('.gx-sort-dropdown__option'));

        if (!this.trigger || !this.panel || !this.select) return;

        this.trigger.addEventListener('click', () => this.toggle());
        this.closeButton?.addEventListener('click', () => this.close());

        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.close();
        });
        document.addEventListener('keyup', (event) => {
          if (event.key === 'Escape') this.close();
        });

        this.options.forEach((option) => {
          option.addEventListener('click', () => {
            this.select.value = option.dataset.value;
            this.select.dispatchEvent(new Event('input', { bubbles: true }));
            this.close();
          });
        });
      }

      toggle() {
        this.panel.hidden ? this.open() : this.close();
      }

      open() {
        this.panel.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.panel.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
      }
    }
  );
}